<section
  class="min-h-[40vh] bg-cover bg-center bg-blend-multiply bg-black/40 flex flex-col justify-center items-center px-3 md:px-5 2xl:px-28 3xl:px-52"
  [ngStyle]="{
    'background-image': 'url(/assets/images/type/' + imageSrc + ')'
  }"
>
  <div class="container mx-auto text-center flex flex-col items-center">
    <h1 class="font-bold text-4xl xl:text-5xl text-white">
      Used Tesla by Listing Type
    </h1>
    <div class="pill-nav">
      <ul class="list-none flex flex-wrap justify-center gap-2.5 mt-3.5">
        <li
          *ngFor="let item of pillItems"
          class="flex items-center"
          routerLinkActive="pill-nav__selected"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          <a
            [routerLink]="item.url"
            class="no-underline text-sm px-3.5 py-0.5 leading-[1.4] border border-[#ffffff] text-white rounded-full hover:bg-white hover:text-OUT-Blue transition-colors duration-400 font-medium"
          >
            {{ item.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</section>
<section class="px-3 md:px-5 2xl:px-28 3xl:px-52 space-y-4 py-10">
  <section class="container mx-auto">
    <router-outlet></router-outlet>
  </section>
</section>
